
import { Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ProfileVO } from '../../vo/user/profile.vo';

@Component({
  selector: 'role-or-profile-renderer',
  template: `<wiz-hgroup height="100%" width="100%" gap="5" horizontalAlign="center" verticalAlign="center">
    <wiz-icon width="18" height="18" style="font-size: 18px;" [wizTooltip]="iconTooltip">{{ iconStr }}</wiz-icon>
  </wiz-hgroup> `,
  styles: [':host {height:100%; width: 100%;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleOrProfileRenderer implements AgRendererComponent {
  data: any;
  params: any;

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {}

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.data = params.data;
    this.params = params;
    this.cdref.markForCheck();
  }

  get iconStr(): string {
    return this.data && this.data instanceof ProfileVO ? 'profiles' : 'roles';
  }

  get iconTooltip(): string {
    return this.data && this.data instanceof ProfileVO ? '$.role.scope.profil.$' : '$.role.scope.role.$';
  }
}
